import { render } from "./modalDetalladoFacturaGenerar.vue?vue&type=template&id=466350f0"
import script from "./modalDetalladoFacturaGenerar.vue?vue&type=script&lang=js"
export * from "./modalDetalladoFacturaGenerar.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Pro-Sistemas08\\OneDrive - PHARMASAN S.A.S\\Documentos\\development\\pharmasan\\new_intranet\\frontend-intv2\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__